import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FiArrowRight, FiLayers, FiMonitor, FiSmartphone } from "react-icons/fi";

const services = [
  {
    id: "uiux",
    title: "Product Design",
    desc: "Product design services for startup MVPs, mobile apps, websites and SaaS platforms, including UX strategy, UI systems, user flows and prototypes.",
    icon: FiLayers,
    link: "/services/uiux",
  },
  {
    id: "web",
    title: "Web & SaaS Development",
    desc: "Web development and SaaS development for startup websites, dashboards, landing pages, portals, admin tools and scalable product platforms.",
    icon: FiMonitor,
    link: "/services/web",
  },
  {
    id: "mobile",
    title: "Mobile App Development",
    desc: "Mobile app development for iOS and Android products with product planning, UX UI design, scalable architecture and launch support.",
    icon: FiSmartphone,
    link: "/services/mobile",
  },
];

export default function Services() {
  const navigate = useNavigate();

  return (
    <main className="premium-page">
      <section className="premium-shell">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="page-hero-block"
        >
          <p className="eyebrow">Services</p>
          <h1 className="hero-heading mt-5">
            From startup idea to product ready for launch.
          </h1>
          <p className="hero-copy">
            Code7s combines startup product strategy, premium UX UI design,
            mobile app development, web development and SaaS engineering so
            founders can move from rough idea to a polished product ready for
            users, investors and launch.
          </p>
        </motion.div>

        <div className="mt-14 grid gap-5 lg:grid-cols-3">
          {services.map((service, index) => {
            const Icon = service.icon;

            return (
              <motion.button
                key={service.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: index * 0.08 }}
                onClick={() => navigate(service.link)}
                className="premium-card rounded-[26px] p-6 text-center"
              >
                <div className="flex flex-col items-center gap-5">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-neutral-950 text-2xl text-white">
                    <Icon aria-hidden="true" />
                  </div>
                  <h2 className="text-2xl font-bold tracking-tight">{service.title}</h2>
                </div>
                <p className="mt-4 leading-7 text-neutral-600">{service.desc}</p>
                <span className="mt-8 inline-flex items-center gap-2 text-sm font-bold">
                  Explore service <FiArrowRight aria-hidden="true" />
                </span>
              </motion.button>
            );
          })}
        </div>

        <section className="glass-card mt-20 rounded-[32px] p-6 md:p-10">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
            <div>
              <p className="section-kicker">Engagement model</p>
              <h2 className="section-heading mt-3">
                Built for startups that need momentum and taste.
              </h2>
            </div>
            <div className="grid gap-4 sm:grid-cols-2">
              {[
                "MVP planning and scope definition",
                "Premium product interface design",
                "Frontend and backend implementation",
                "Store, web, or cloud launch support",
                "Iteration and maintenance after launch",
                "Product experiments published by Code7s",
              ].map((item) => (
                <div key={item} className="glass-card rounded-2xl p-5 font-semibold text-neutral-700">
                  {item}
                </div>
              ))}
            </div>
          </div>
        </section>
      </section>
    </main>
  );
}
